import { isAppStateReady } from 'src/state/store'
import { logger, readHashParam } from '$utils'
import useWorkforceStore from '../store'
import { defer } from 'react-router-dom'
import { APPROVALS_TAB_KEYS } from './_common/contants'

export default async function loader() {
  // initialise the store with the right tab based on the url param
  const requestedTab = readHashParam('tab')
  const { activeApprovalsTab, setActiveApprovalsTab } =
    useWorkforceStore.getState()
  if (
    (requestedTab === APPROVALS_TAB_KEYS.leaveAndUnavailability ||
      requestedTab === APPROVALS_TAB_KEYS.shiftSwapping) &&
    // Only when the tab really changes: the setter also clears the request type filter, and
    // coming back from the manage request route re-runs this loader with the tab still in
    // the url. Without this check that return trip would wipe a filter the user had chosen.
    requestedTab !== activeApprovalsTab
  ) {
    setActiveApprovalsTab(requestedTab)
  }

  logger.debug(
    '[loader] About to await AppState being ready in Approvals loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in Approvals loader')

  // Staff, leave types and roles back the filter dropdowns. The rows are fetched per-tab from the
  // approvals endpoint.
  const getStaffMembers = useWorkforceStore.getState().getStaffMembers()
  const getLeaveTypes = useWorkforceStore.getState().getLeaveTypes()
  const getStaffRoles = useWorkforceStore.getState().getStaffRoles(false)

  return defer({
    data: Promise.all([getStaffMembers, getLeaveTypes, getStaffRoles])
      .then(() => true)
      .catch((error) => {
        logger.error('Approvals Promise.all error', error)
        return false
      }),
  })
}
